import { render, staticRenderFns } from "./CricleTriangle.vue?vue&type=template&id=73006b8c&"
import script from "./CricleTriangle.vue?vue&type=script&lang=js&"
export * from "./CricleTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports